/* eslint-disable no-case-declarations */
import ACTIONS from '../actionTypes';
import * as c from '../constants';
const makeArrayKlarna = (state, klarnas) => {
    let newArrayKlarna = [...state.paymentMethods];
    klarnas.map(klarna => {
        newArrayKlarna = [klarna, ...newArrayKlarna];
    });
    return newArrayKlarna;
};
const makeArrayFloa = (state, floa) => {
    let newArrayFloa = [...state.paymentMethods];
    return (newArrayFloa = [...newArrayFloa, floa]);
};
function reducer(state = c.DEFAULT_STATE, action) {
    switch (action.type) {
        case ACTIONS.SHOW:
            const PaymentMeanDetailsModalDetail = action.payload;
            return Object.assign(Object.assign({}, state), { visible: true, isFloaLoaded: true, isKlarnaLoaded: true, error: false, paymentMethods: [...PaymentMeanDetailsModalDetail.paymentMethods], isEligibleToKlarna: PaymentMeanDetailsModalDetail.isEligibleToKlarna, isEligibleToFloa10x: PaymentMeanDetailsModalDetail.isEligibleToFloa10x, isEligibleToPaypal4x: PaymentMeanDetailsModalDetail.isEligibleToPaypal4x, price: PaymentMeanDetailsModalDetail.price });
        case ACTIONS.HIDE:
            return Object.assign(Object.assign({}, state), { visible: false, error: false, paymentMethods: [] });
        case ACTIONS.KLARNA:
            return Object.assign(Object.assign({}, state), { visible: true, error: false, isKlarnaLoaded: true, paymentMethods: makeArrayKlarna(state, action.payload) });
        case ACTIONS.FLOA:
            return Object.assign(Object.assign({}, state), { visible: true, error: false, isFloaLoaded: true, paymentMethods: makeArrayFloa(state, action.payload) });
        case ACTIONS.START_LOADING_KLARNA:
            return Object.assign(Object.assign({}, state), { isKlarnaLoaded: false });
        case ACTIONS.START_LOADING_FLOA:
            return Object.assign(Object.assign({}, state), { isFloaLoaded: false });
        case ACTIONS.HANDLE_ERROR:
            return Object.assign(Object.assign({}, state), { error: true, isFloaLoaded: true, isKlarnaLoaded: true });
        default:
            return state;
    }
}
export default reducer;
